import React from "react";
import { Link } from "react-router-dom";
import { Cake, Heart, Gift, Stars, Baby, Home, Car, Utensils } from "lucide-react";
import { cn } from "../lib/utils";

const items = [
  { name: "Birthday", icon: Cake, color: "bg-pink-100 text-pink-600", path: "/category/kid-s-special?subcategory=kids-birthday" },
  { name: "Candlelight", icon: Utensils, color: "bg-purple-100 text-purple-600", path: "/category/couple-s-special?subcategory=candlelight-dinner" },
  { name: "Room Decor", icon: Home, color: "bg-blue-100 text-blue-600", path: "/category/couple-s-special?subcategory=romantic-room-decoration" },
  { name: "Anniversary", icon: Heart, color: "bg-red-100 text-red-600", path: "/category/premium-setup?subcategory=anniversary-decor" },
  { name: "Cabana", icon: Stars, color: "bg-amber-100 text-amber-600", path: "/category/premium-setup?subcategory=cabana-setup" },
  { name: "Baby Shower", icon: Baby, color: "bg-teal-100 text-teal-600", path: "/category/kid-s-special?subcategory=welcome-baby" },
  { name: "Car Decor", icon: Car, color: "bg-slate-100 text-slate-600", path: "/category/couple-s-special?subcategory=car-boot-decor" },
  { name: "Surprises", icon: Gift, color: "bg-orange-100 text-orange-600", path: "/category/festival-decorations" },
];

export const QuickLinks = () => {
  return (
    <section className="py-10 bg-background" data-testid="quick-links">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex gap-6 sm:gap-10 overflow-x-auto no-scrollbar pb-4 -mx-4 px-4 sm:mx-0 sm:px-0 justify-start sm:justify-center">
          {items.map((item) => (
            <Link
              key={item.name}
              to={item.path}
              className="group flex flex-col items-center gap-3 shrink-0 transition-transform active:scale-95"
            >
              <div className={cn(
                "w-16 h-16 sm:w-20 sm:h-20 rounded-full flex items-center justify-center transition-all duration-300 group-hover:shadow-lg group-hover:-translate-y-1",
                item.color
              )}>
                <item.icon className="w-8 h-8 sm:w-10 sm:h-10 transition-transform group-hover:scale-110" strokeWidth={1.5} />
              </div>
              <span className="text-xs sm:text-sm font-semibold text-foreground/80 group-hover:text-primary transition-colors whitespace-nowrap">
                {item.name}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};
